var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.295 5.705C17.9056 5.31564 17.2743 5.31564 16.885 5.705L12 10.59L7.11499 5.705C6.72563 5.31564 6.09435 5.31564 5.70499 5.705C5.31563 6.09436 5.31563 6.72564 5.70499 7.115L10.59 12L5.70499 16.885C5.31563 17.2744 5.31563 17.9056 5.70499 18.295C6.09435 18.6844 6.72563 18.6844 7.11499 18.295L12 13.41L16.885 18.295C17.2743 18.6844 17.9056 18.6844 18.295 18.295C18.6843 17.9056 18.6843 17.2744 18.295 16.885L13.41 12L18.295 7.115C18.6843 6.72564 18.6843 6.09436 18.295 5.705Z",
    fill: "#47474B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3b7f3f8fce92286f10380db5671579c7.svg";
export { ForwardRef as ReactComponent };